import { ProviderAssociationHistoryEntry, ProviderEmployerAssociation } from '~/types';
import { deleteData, getData } from '~/utils/service';

export const getCurrentAssociation = async () => {
  return getData<ProviderEmployerAssociation>('providerAssociationCurrent');
};

export const disassociate = async () => {
  return deleteData('providerAssociationDisassociate');
};

// [MCV-1927] The employers this provider was once associated with, newest first.
export const getProviderAssociationHistory = async () => {
  return getData<ProviderAssociationHistoryEntry[]>('providerAssociationProviderHistory');
};
